$(document).ready(function () {
  $(document).on("click", ".switch_dimenion span", function () {
    var $toggle = $(this).closest('.toggle-label');
    $toggle.find('.switch_dimenion span').removeClass("active");
    $(this).addClass("active");
    var unit = $(this).attr("dimentionType");
    $toggle.next().find('span').each(function () {
      var $s = $(this);
      // remember the original cm value so repeated toggles never drift
      if ($s.attr('data-cm') === undefined) $s.attr('data-cm', $s.text().trim());
      var cm = parseFloat($s.attr('data-cm'));
      if (isNaN(cm)) return;
      $s.text(unit === 'cm' ? $s.attr('data-cm') : (cm / 2.54).toFixed(2));
    });
  });
});
